<template lang="html">
	<div
	id="casestudy"
	data-sal="slide-up"
	data-sal-duration="2000"
	data-sal-easing="ease-out-back"
	class="section-container">
	<h1>Case Study</h1>
		<iframe 
		src="https://player.vimeo.com/video/652061093?h=f34776f00c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Little Caesars - Let&amp;#039;s Get Social!">
		</iframe>	
	</div>
</template>

<script>
import sal from "sal.js"; // No need to use in main.js file

export default {
    mounted() {
        sal();
    },
}
</script>

<style scoped lang="scss">
.section-container {
	width: 80%;
	max-width: 800px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	h1 {
		padding-bottom: 30px;
		font-family: $heading-font;
		color:white;
		text-decoration: underline;
		font-size:60px;
		text-transform: uppercase;
		font-weight: 900;
		margin-top:50px;
	}
}
    
</style>